export const LANGS = [
  { code: "tr", label: "Türkçe", short: "TR", dir: "ltr" },
  { code: "en", label: "English", short: "EN", dir: "ltr" },
  { code: "ru", label: "Русский", short: "RU", dir: "ltr" },
  { code: "ar", label: "العربية", short: "AR", dir: "rtl" },
];

export const translations = {
  tr: {
    nav: {
      home: "Ana Sayfa",
      packages: "Tarifeler",
      services: "Hizmetler",
      corporate: "Kurumsal",
      onlineBasvuru: "Online Başvuru",
      campaigns: "Kampanyalar",
      blog: "Blog",
      faq: "SSS",
      contact: "İletişim",
      online: "Online İşlemler",
      applyNow: "Hemen Başvur",
      callYou: "Sizi Arayalım",
      coverage: "Altyapı Sorgula",
      individual: "Bireysel",
      speedTest: "Hız Testi",
      fastActions: "Hızlı İşlemler",
    },
    hero: {
      badge: "SİLİFKE'NİN AIR FİBER ALTYAPISI",
      title1: "Işık Hızında",
      title2: "İnternet.",
      subtitle:
        "EntaNET ile eve kadar AIR Fiber teknolojisini keşfedin. 100 Mbps'e varan hız, sınırsız kota ve 08:00 - 20:00 yerel teknik destek.",
      ctaPackages: "Tarifeleri İncele",
      ctaContact: "Bize Ulaşın",
      coverageTitle: "Altyapı Sorgula",
      coveragePlaceholder: "Mahalle / adresinizi yazın...",
      coverageBtn: "Sorgula",
      onlineBasvuruTitle: "E-Devlet Online Başvuru",
      onlineBasvuruDesc: "e-Devlet ile güvenli ve hızlı abonelik başvurusu yapın",
      onlineBasvuruBtn: "Hemen Başvur",
      onlineBasvuruFeat1: "e-Devlet ile anında kimlik doğrulama",
      onlineBasvuruFeat2: "Tamamen dijital, evrak gerektirmez",
      onlineBasvuruFeat3: "Saniyeler içinde başvuru tamamlama",
      statSpeed: "Maksimum Hız",
      statSpeedNote: "Daha Yüksek Hız İçin Firmamızla İletişime Geçiniz",
      statSupport: "Teknik Destek",
      statUptime: "Çalışma Süresi",
      statLocal: "Yerel Hizmet",
      slide1Badge: "TAAHHÜTSÜZ & SINIRSIZ",
      slide1Title: "Sınırsız Hız,",
      slide1Title2: "Taahhütsüz İnternet",
      slide1Desc: "100 Mbps'e varan hız, sınırsız kota ve 08:00 - 20:00 yerel teknik destek.",
      slide2Badge: "YEREL GÜÇ",
      slide2Title: "Silifke'nin",
      slide2Title2: "AIR Fiber Altyapısı",
      slide2Desc: "Eve kadar AIR Fiber teknolojisi, komşu gibi hizmet anlayışı.",
      slide3Badge: "HEMEN BAĞLAN",
      slide3Title: "Hızlı Başvuru,",
      slide3Title2: "Hızlı Bağlantı",
      slide3Desc: "Bugün başvurun, 1-3 iş gününde AIR Fiber internetinize kavuşun.",
    },
    home: {
      whyTitle: "Neden EntaNET?",
      whySubtitle: "Bölgenin en güçlü AIR Fiber altyapısını yerel hizmet anlayışıyla birleştiriyoruz.",
      why1Title: "Gerçek AIR Fiber Altyapı",
      why1Desc: "Eve kadar AIR Fiber (FTTH) ile taahhüt ettiğimiz hızı gerçekten alırsınız.",
      why2Title: "Sınırsız Kullanım",
      why2Desc: "Adil kullanım kotası yok. Dilediğiniz kadar indirin, izleyin, oynayın.",
      why3Title: "08:00 - 20:00 Yerel Destek",
      why3Desc: "Çağrı merkezi labirentleri yok. Silifke'deki ekibimiz 08:00 - 20:00 saatleri arasında yanınızda.",
      why4Title: "Şeffaf Fiyatlandırma",
      why4Desc: "Gizli ücret yok, sürpriz zam yok. Ne ödediğinizi her zaman bilirsiniz.",
      packagesTitle: "Size Uygun Tarifeyi Seçin",
      packagesSubtitle: "Her ihtiyaca ve bütçeye uygun AIR Fiber internet paketleri.",
      priceNoticeTitle: "Duyuru",
      priceNotice: "Sayın Enta-Net Kullanıcılarımız, BTK'nin 2026/DK-ETD/134 sayılı kararı ile onaylanan toptan hizmetlerdeki fiyat güncellemeleri nedeniyle maliyetlerimizdeki artışlara bağlı olarak, internet hizmetlerimizde 17.08.2026 tarihinden itibaren fiyat güncelleme zorunluluğu doğmuştur. Güncel fiyatlar web sayfamızda yayımlanmıştır. Göstermiş olduğunuz anlayış ve bize duyduğunuz güven için teşekkür ederiz. Sorularınız veya detaylı bilgi almak için bizimle iletişime geçmekten çekinmeyiniz.",
      priceNoticeDate: "Duyuru Tarihi: 17.07.2026",
      priceTable: {
        title: "Fiyat Değişiminden Etkilenen Tarifelerimiz",
        colName: "Tarife Adı",
        colPrice: "Fiyat",
      },
      allPackages: "Tüm Tarifeleri Gör",
      servicesTitle: "Hizmetlerimiz",
      servicesSubtitle: "Bireysel ve kurumsal tüm bağlantı ihtiyaçlarınız için tek adres.",
      campaignsTitle: "Güncel Kampanyalar",
      offerFeat1: "100 Mbps'e kadar indirme hızı",
      offerFeat2: "12 ay boyunca sabit fiyat garantisi",
      offerFeat3: "Taahhüt yok, istediğin zaman iptal et",
      offerFeat4: "e-Devlet ile anında dijital onay",
      ctaTitle: "Hızın özgürlüğünü yaşamaya hazır mısınız?",
      ctaSubtitle: "Bugün başvurun, 1-3 iş günü içinde AIR Fiber internetinize kavuşun.",
      ctaButton: "Hemen Başvur",
    },
    packages: {
      title: "Tarifeler",
      subtitle: "Sınırsız, taahhüt seçenekli ve şeffaf fiyatlı AIR Fiber internet paketleri.",
      perMonth: "/ay",
      popular: "EN POPÜLER",
      select: "Tarife Detayları",
      mbps: "Mbps",
      note: "Fiyatlara KDV ve ÖİV dahildir. Altyapı uygunluğuna göre hizmet verilmektedir.",
    },
    packageDetail: {
      back: "Tarifelere Dön",
      speedTitle: "İndirme Hızı",
      speedDesc: "Saniyede maksimum veri aktarım hızı",
      priceTitle: "Aylık Ücret",
      priceDesc: "KDV ve ÖİV dahil sabit fiyat",
      featuresTitle: "Paket Özellikleri",
      featuresDesc: "Bu tarifeye dahil olan tüm hizmetler",
      applyNow: "Hemen Başvur",
      contactUs: "Bize Ulaşın",
      note: "Fiyatlara KDV ve ÖİV dahildir. Altyapı uygunluğuna göre hizmet verilmektedir.",
      notFound: "Tarife bulunamadı.",
      notFoundDesc: "Aradığınız tarife mevcut değil veya kaldırılmış olabilir.",
    },
    services: {
      title: "Hizmetler",
      subtitle: "Bireyselden kurumsala, eviniz ve işiniz için eksiksiz bağlantı çözümleri.",
    },
    about: {
      title: "Kurumsal",
      subtitle: "Bölgemizi geleceğin internetiyle buluşturuyoruz.",
      storyTitle: "Hikayemiz",
      p1: "ENTA-NET TELEKOMÜNİKASYON VE BİLGİ TEKNOLOJİLERİ TİCARET LİMİTED ŞİRKETİ, Mersin'in Silifke ilçesinde kurulmuş, bölgesine yüksek hızlı ve güvenilir internet erişimi sunmayı amaç edinmiş bir internet servis sağlayıcısıdır.",
      p2: "Kurulduğumuz günden bu yana, büyük operatörlerin yeterince yatırım yapmadığı bölgelere modern AIR Fiber altyapı taşıyor; her haneye ve işletmeye büyük şehir kalitesinde internet hizmeti ulaştırıyoruz.",
      p3: "Yerel bir şirket olmanın gücüyle, abonelerimize sadece bir müşteri numarası gibi değil, komşumuz gibi davranıyoruz. Teknik ekibimiz aynı gün müdahale, 08:00 - 20:00 destek ve şeffaf fiyatlandırma ilkeleriyle çalışır.",
      missionTitle: "Misyonumuz",
      missionText: "Bölgemizdeki her haneye ve işletmeye, hızlı, kesintisiz ve uygun fiyatlı internet erişimi sağlamak.",
      visionTitle: "Vizyonumuz",
      visionText: "Mersin ve çevresinin dijital dönüşümüne öncülük eden, en güvenilir bölgesel telekomünikasyon şirketi olmak.",
      valuesTitle: "Değerlerimiz",
      value1: "Güvenilirlik",
      value1Desc: "Verdiğimiz sözü tutarız; taahhüt ettiğimiz hızı sunarız.",
      value2: "Yerellik",
      value2Desc: "Bölgemizi tanırız, abonelerimize komşumuz gibi davranırız.",
      value3: "Yenilikçilik",
      value3Desc: "Altyapımızı sürekli geliştirir, en yeni teknolojiyi bölgemize taşırız.",
    },
    blog: {
      title: "Blog & Haberler",
      subtitle: "EntaNET'ten haberler, teknoloji rehberleri ve duyurular.",
      readMore: "Devamını Oku",
      back: "Tüm Yazılar",
      empty: "Henüz yazı bulunmuyor.",
    },
    campaigns: {
      title: "Kampanyalar",
      subtitle: "Size özel fırsatları kaçırmayın.",
      apply: "Kampanyadan Yararlan",
      empty: "Şu anda aktif kampanya bulunmuyor.",
    },
    faq: {
      title: "Sıkça Sorulan Sorular",
      subtitle: "Merak ettikleriniz için hızlı yanıtlar.",
      moreTitle: "Sorunuzun yanıtını bulamadınız mı?",
      moreText: "Ekibimiz tüm sorularınız için 08:00 - 20:00 saatleri arasında hazır.",
      moreCta: "Bize Ulaşın",
    },
    contact: {
      title: "İletişim",
      subtitle: "Sorularınız, başvurularınız ve destek talepleriniz için buradayız.",
      formTitle: "Bize Yazın",
      name: "Ad Soyad",
      email: "E-posta",
      phone: "Telefon",
      subject: "Konu",
      message: "Mesajınız",
      send: "Gönder",
      sending: "Gönderiliyor...",
      success: "Mesajınız başarıyla iletildi. En kısa sürede dönüş yapacağız.",
      error: "Mesaj gönderilemedi. Lütfen tekrar deneyin.",
      infoTitle: "İletişim Bilgileri",
      addressLabel: "Adres",
      phoneLabel: "Telefon",
      emailLabel: "E-posta",
      hoursLabel: "Çalışma Saatleri",
      hours: "Pazartesi - Cumartesi: 09.00 - 18.00",
      consentIntro: "",
      termsLink: "Kullanım Koşulları",
      consentMid: " ve ",
      privacyLink: "Gizlilik Sözleşmesi",
      consentOutro: "'ni okudum, kabul ediyorum.",
      consentRequired: "Devam etmek için kullanım koşullarını ve gizlilik sözleşmesini kabul etmelisiniz.",
    },
    footer: {
      tagline: "Silifke ve çevresine yüksek hızlı AIR Fiber internet. Yerel güç, küresel hız.",
      quickLinks: "Hızlı Bağlantılar",
      services: "Hizmetler",
      contact: "İletişim",
      rights: "Tüm hakları saklıdır.",
    },
    cookie: {
      title: "Çerez Kullanıyoruz",
      text: "Web sitemizde daha iyi bir deneyim sunabilmek amacıyla çerezler (cookie) kullanılmaktadır. 6698 sayılı KVKK ve aydınlatma yükümlülüğü kapsamında, çerez kullanımımızı kabul edebilir veya ayarlarınızı yönetebilirsiniz.",
      policyLink: "Çerez Politikası",
      acceptAll: "Tümünü Kabul Et",
      reject: "Yalnızca Gerekli Çerezler",
      settings: "Ayarlar",
      close: "Kapat",
      catNecessary: "Gerekli Çerezler",
      catNecessaryDesc: "Web sitesinin düzgün çalışması için zorunludur. Devre dışı bırakılamaz.",
      catAnalytics: "Analitik Çerezler",
      catAnalyticsDesc: "Site kullanımını analiz etmek ve deneyimi iyileştirmek için kullanılır.",
      catMarketing: "Pazarlama Çerezleri",
      catMarketingDesc: "İlgi alanınıza uygun içerik ve reklamlar sunmak için kullanılır.",
      save: "Ayarları Kaydet",
      poweredBy: "KVKK ve GDPR uyumlu",
    },
    common: {
      loading: "Yükleniyor...",
    },
    comingSoon: {
      badge: "YAPIM AŞAMASINDA",
      title1: "Yenilenen Dijital",
      title2: "Deneyimimiz",
      subtitle:
        "Kurumsal web sitemiz üzerinde titizlikle çalışıyoruz. Yeni yüzümüz hazırlanana dek hizmetlerimiz kesintisiz devam ediyor.",
      paymentBtn: "Ödeme Yapmak İçin Tıklayınız",
      paymentNote: "Online ödeme sistemine güvenle yönlendirilirsiniz.",
      contactTitle: "Bize Ulaşın",
      brandTagline: "Silifke'nin AIR Fiber altyapısı — yerel güç, küresel hız.",
    },
  },

  en: {
    nav: {
      home: "Home",
      packages: "Plans",
      services: "Services",
      corporate: "About Us",
      onlineBasvuru: "Online Application",
      campaigns: "Campaigns",
      blog: "Blog",
      faq: "FAQ",
      contact: "Contact",
      online: "Online Services",
      applyNow: "Apply Now",
      callYou: "Call You Back",
      coverage: "Check Coverage",
      individual: "Individual",
      speedTest: "Speed Test",
      fastActions: "Quick Actions",
    },
    hero: {
      badge: "SİLİFKE'S FIBER INFRASTRUCTURE",
      title1: "Internet at the",
      title2: "Speed of Light.",
      subtitle:
        "Discover AIR Fiber technology with EntaNET. Speeds up to 100 Mbps, unlimited quota and 08:00 - 20:00 local technical support.",
      ctaPackages: "View Plans",
      ctaContact: "Contact Us",
      coverageTitle: "Check Coverage",
      coveragePlaceholder: "Enter your neighborhood / address...",
      coverageBtn: "Check",
      onlineBasvuruTitle: "e-Government Online Application",
      onlineBasvuruDesc: "Secure and fast subscription application via e-Government",
      onlineBasvuruBtn: "Apply Now",
      onlineBasvuruFeat1: "Instant identity verification via e-Government",
      onlineBasvuruFeat2: "Fully digital, no paperwork required",
      onlineBasvuruFeat3: "Complete your application in seconds",
      statSpeed: "Maximum Speed",
      statSpeedNote: "Contact us for higher speeds",
      statSupport: "Technical Support",
      statUptime: "Uptime",
      statLocal: "Local Service",
      slide1Badge: "UNLIMITED & COMMITMENT-FREE",
      slide1Title: "Unlimited Speed,",
      slide1Title2: "Commitment-Free Internet",
      slide1Desc: "Speeds up to 100 Mbps, unlimited quota and 08:00 - 20:00 local technical support.",
      slide2Badge: "LOCAL POWER",
      slide2Title: "Silifke's",
      slide2Title2: "AIR Fiber Infrastructure",
      slide2Desc: "AIR Fiber technology with neighbor-like service.",
      slide3Badge: "CONNECT NOW",
      slide3Title: "Easy Application,",
      slide3Title2: "Fast Connection",
      slide3Desc: "Apply today, get your AIR Fiber internet within 1-3 business days.",
    },
    home: {
      whyTitle: "Why EntaNET?",
      whySubtitle: "We combine the region's strongest AIR Fiber infrastructure with a local service mindset.",
      why1Title: "True AIR Fiber Infrastructure",
      why1Desc: "With AIR Fiber (FTTH), you actually get the speed we promise.",
      why2Title: "Unlimited Usage",
      why2Desc: "No fair usage quota. Download, stream and play as much as you want.",
      why3Title: "08:00 - 20:00 Local Support",
      why3Desc: "No call center mazes. Our team in Silifke is by your side 08:00 - 20:00.",
      why4Title: "Transparent Pricing",
      why4Desc: "No hidden fees, no surprise increases. You always know what you pay.",
      packagesTitle: "Choose the Right Plan for You",
      packagesSubtitle: "AIR Fiber internet packages for every need and budget.",
      priceNoticeTitle: "Announcement",
      priceNotice: "Dear Enta-Net Users, due to the wholesale price updates approved by the BTK decision numbered 2026/DK-ETD/134 and the resulting increase in our costs, a price update has become necessary for our internet services starting from 17.08.2026. Updated prices are published on our website. Thank you for your understanding and the trust you place in us. Please do not hesitate to contact us with your questions or for detailed information.",
      priceNoticeDate: "Announcement Date: 17.07.2026",
      priceTable: {
        title: "Our Tariffs Affected by the Price Change",
        colName: "Plan Name",
        colPrice: "Price",
      },
      allPackages: "See All Plans",
      servicesTitle: "Our Services",
      servicesSubtitle: "One address for all your residential and corporate connectivity needs.",
      campaignsTitle: "Current Campaigns",
      offerFeat1: "Download speeds up to 100 Mbps",
      offerFeat2: "12-month fixed price guarantee",
      offerFeat3: "No commitment, cancel anytime",
      offerFeat4: "Instant digital approval via e-Government",
      ctaTitle: "Ready to experience the freedom of speed?",
      ctaSubtitle: "Apply today, get your AIR Fiber internet within 1-3 business days.",
      ctaButton: "Apply Now",
    },
    packages: {
      title: "Plans",
      subtitle: "Unlimited AIR Fiber internet packages with commitment options and transparent pricing.",
      perMonth: "/mo",
      popular: "MOST POPULAR",
      select: "Plan Details",
      mbps: "Mbps",
      note: "Prices include VAT. Service is subject to infrastructure availability.",
    },
    packageDetail: {
      back: "Back to Plans",
      speedTitle: "Download Speed",
      speedDesc: "Maximum data transfer rate per second",
      priceTitle: "Monthly Fee",
      priceDesc: "Fixed price including VAT",
      featuresTitle: "Package Features",
      featuresDesc: "All services included in this plan",
      applyNow: "Apply Now",
      contactUs: "Contact Us",
      note: "Prices include VAT. Service is subject to infrastructure availability.",
      notFound: "Plan not found.",
      notFoundDesc: "The plan you are looking for may not exist or has been removed.",
    },
    services: {
      title: "Services",
      subtitle: "Complete connectivity solutions for your home and business.",
    },
    about: {
      title: "About Us",
      subtitle: "Connecting our region with the internet of the future.",
      storyTitle: "Our Story",
      p1: "ENTA-NET TELEKOMÜNİKASYON VE BİLGİ TEKNOLOJİLERİ TİCARET LİMİTED ŞİRKETİ is an internet service provider founded in Silifke, Mersin, dedicated to providing high-speed and reliable internet access to its region.",
      p2: "Since our founding, we have been bringing modern AIR Fiber infrastructure to areas underserved by major operators, delivering big-city quality internet to every household and business.",
      p3: "With the strength of being a local company, we treat our subscribers like neighbors, not customer numbers. Our technical team operates with same-day response, 08:00 - 20:00 support and transparent pricing principles.",
      missionTitle: "Our Mission",
      missionText: "To provide fast, uninterrupted and affordable internet access to every household and business in our region.",
      visionTitle: "Our Vision",
      visionText: "To be the most trusted regional telecommunications company leading the digital transformation of Mersin and its surroundings.",
      valuesTitle: "Our Values",
      value1: "Reliability",
      value1Desc: "We keep our word; we deliver the speed we promise.",
      value2: "Local Roots",
      value2Desc: "We know our region and treat our subscribers like neighbors.",
      value3: "Innovation",
      value3Desc: "We continuously improve our infrastructure and bring the latest technology to our region.",
    },
    blog: {
      title: "Blog & News",
      subtitle: "News, technology guides and announcements from EntaNET.",
      readMore: "Read More",
      back: "All Posts",
      empty: "No posts yet.",
    },
    campaigns: {
      title: "Campaigns",
      subtitle: "Don't miss out on exclusive offers.",
      apply: "Get This Offer",
      empty: "There are no active campaigns at the moment.",
    },
    faq: {
      title: "Frequently Asked Questions",
      subtitle: "Quick answers to your questions.",
      moreTitle: "Couldn't find your answer?",
      moreText: "Our team is available 08:00 - 20:00 for all your questions.",
      moreCta: "Contact Us",
    },
    contact: {
      title: "Contact",
      subtitle: "We're here for your questions, applications and support requests.",
      formTitle: "Write to Us",
      name: "Full Name",
      email: "Email",
      phone: "Phone",
      subject: "Subject",
      message: "Your Message",
      send: "Send",
      sending: "Sending...",
      success: "Your message has been sent. We'll get back to you shortly.",
      error: "Message could not be sent. Please try again.",
      infoTitle: "Contact Information",
      addressLabel: "Address",
      phoneLabel: "Phone",
      emailLabel: "Email",
      hoursLabel: "Working Hours",
      hours: "Monday - Saturday: 09:00 - 18:00",
      consentIntro: "I have read and accept the ",
      termsLink: "Terms of Use",
      consentMid: " and ",
      privacyLink: "Privacy Policy",
      consentOutro: ".",
      consentRequired: "Please accept the terms of use and privacy policy to continue.",
    },
    footer: {
      tagline: "High-speed AIR Fiber internet for Silifke and its surroundings. Local strength, global speed.",
      quickLinks: "Quick Links",
      services: "Services",
      contact: "Contact",
      rights: "All rights reserved.",
    },
    cookie: {
      title: "We Use Cookies",
      text: "We use cookies to provide a better experience on our website. Under KVKK Law No. 6698 and GDPR, you can accept our use of cookies or manage your settings.",
      policyLink: "Cookie Policy",
      acceptAll: "Accept All",
      reject: "Necessary Only",
      settings: "Settings",
      close: "Close",
      catNecessary: "Necessary Cookies",
      catNecessaryDesc: "Required for the website to function properly. Cannot be disabled.",
      catAnalytics: "Analytics Cookies",
      catAnalyticsDesc: "Used to analyze site usage and improve the experience.",
      catMarketing: "Marketing Cookies",
      catMarketingDesc: "Used to deliver content and ads relevant to your interests.",
      save: "Save Settings",
      poweredBy: "KVKK & GDPR compliant",
    },
    common: {
      loading: "Loading...",
    },
    comingSoon: {
      badge: "UNDER CONSTRUCTION",
      title1: "A Renewed Digital",
      title2: "Experience",
      subtitle:
        "We are carefully crafting our new corporate website. Until it is ready, our services continue without interruption.",
      paymentBtn: "Click to Make a Payment",
      paymentNote: "You will be securely redirected to our online payment portal.",
      contactTitle: "Get in Touch",
      brandTagline: "Silifke's AIR Fiber backbone — local strength, global speed.",
    },
  },

  ru: {
    nav: {
      home: "Главная",
      packages: "Тарифы",
      services: "Услуги",
      corporate: "О нас",
      onlineBasvuru: "Онлайн-заявка",
      campaigns: "Акции",
      blog: "Блог",
      faq: "Вопросы",
      contact: "Контакты",
      online: "Онлайн-услуги",
      applyNow: "Подать заявку",
      callYou: "Перезвонить вам",
      coverage: "Проверить покрытие",
      individual: "Частное лицо",
      speedTest: "Тест скорости",
      fastActions: "Быстрые действия",
    },
    hero: {
      badge: "ОПТОВОЛОКОННАЯ СЕТЬ СИЛИФКЕ",
      title1: "Интернет со",
      title2: "скоростью света.",
      subtitle:
        "Откройте для себя технологию «оптика до дома» с EntaNET. Скорость до 100 Мбит/с, безлимитный трафик и местная техподдержка 08:00 - 20:00.",
      ctaPackages: "Смотреть тарифы",
      ctaContact: "Связаться с нами",
      coverageTitle: "Проверить покрытие",
      coveragePlaceholder: "Введите ваш район / адрес...",
      coverageBtn: "Проверить",
      onlineBasvuruTitle: "Онлайн-заявка через e-Devlet",
      onlineBasvuruDesc: "Безопасная и быстрая заявка на подписку через e-Devlet",
      onlineBasvuruBtn: "Подать заявку",
      onlineBasvuruFeat1: "Мгновенная проверка личности через e-Devlet",
      onlineBasvuruFeat2: "Полностью цифровая, без документов",
      onlineBasvuruFeat3: "Оформите заявку за секунды",
      statSpeed: "Максимальная скорость",
      statSpeedNote: "Свяжитесь с нами для более высоких скоростей",
      statSupport: "Техподдержка",
      statUptime: "Время работы",
      statLocal: "Местный сервис",
      slide1Badge: "БЕЗЛИМИТ И БЕЗ ОБЯЗАТЕЛЬСТВ",
      slide1Title: "Безлимитная скорость,",
      slide1Title2: "интернет без обязательств",
      slide1Desc: "Скорость до 100 Мбит/с, безлимитный трафик и местная техподдержка 08:00 - 20:00.",
      slide2Badge: "МЕСТНАЯ СИЛА",
      slide2Title: "Волоконная",
      slide2Title2: "инфраструктура Силифке",
      slide2Desc: "Оптика до дома и сервис как для соседей.",
      slide3Badge: "ПОДКЛЮЧАЙТЕСЬ",
      slide3Title: "Быстрая заявка,",
      slide3Title2: "быстрое подключение",
      slide3Desc: "Подайте заявку сегодня — подключим за 1-3 рабочих дня.",
    },
    home: {
      whyTitle: "Почему EntaNET?",
      whySubtitle: "Мы сочетаем сильнейшую оптоволоконную инфраструктуру региона с местным сервисом.",
      why1Title: "Настоящее оптоволокно",
      why1Desc: "С технологией FTTH вы реально получаете обещанную скорость.",
      why2Title: "Безлимитный трафик",
      why2Desc: "Никаких квот. Скачивайте, смотрите и играйте сколько хотите.",
      why3Title: "Поддержка 08:00 - 20:00",
      why3Desc: "Никаких лабиринтов колл-центров. Наша команда в Силифке рядом с 08:00 до 20:00.",
      why4Title: "Прозрачные цены",
      why4Desc: "Без скрытых платежей и неожиданных повышений. Вы всегда знаете, за что платите.",
      packagesTitle: "Выберите подходящий тариф",
      packagesSubtitle: "Пакеты оптоволоконного интернета на любые потребности и бюджет.",
      priceNoticeTitle: "Объявление",
      priceNotice: "Уважаемые пользователи Enta-Net! В связи с обновлением цен на оптовые услуги, утверждённым решением BTK № 2026/DK-ETD/134, и вызванным этим ростом наших затрат, с 17.08.2026 в наших интернет-услугах вступает в силу обновление цен. Актуальные цены опубликованы на нашем веб-сайте. Благодарим вас за понимание и оказанное доверие. Если у вас есть вопросы или нужна подробная информация, пожалуйста, свяжитесь с нами.",
      priceNoticeDate: "Дата объявления: 17.07.2026",
      priceTable: {
        title: "Наши тарифы, затронутые изменением цен",
        colName: "Название тарифа",
        colPrice: "Цена",
      },
      allPackages: "Все тарифы",
      servicesTitle: "Наши услуги",
      servicesSubtitle: "Все решения для подключения дома и бизнеса в одном месте.",
      campaignsTitle: "Текущие акции",
      offerFeat1: "Скорость загрузки до 100 Мбит/с",
      offerFeat2: "Гарантия фиксированной цены на 12 месяцев",
      offerFeat3: "Без обязательств, отмена в любое время",
      offerFeat4: "Мгновенное цифровое подтверждение через e-Devlet",
      ctaTitle: "Готовы ощутить свободу скорости?",
      ctaSubtitle: "Подайте заявку сегодня — подключим за 1-3 рабочих дня.",
      ctaButton: "Подать заявку",
    },
    packages: {
      title: "Тарифы",
      subtitle: "Безлимитные пакеты оптоволоконного интернета с прозрачными ценами.",
      perMonth: "/мес",
      popular: "САМЫЙ ПОПУЛЯРНЫЙ",
      select: "Детали тарифа",
      mbps: "Мбит/с",
      note: "Цены включают НДС. Услуга зависит от наличия инфраструктуры.",
    },
    packageDetail: {
      back: "К тарифам",
      speedTitle: "Скорость загрузки",
      speedDesc: "Максимальная скорость передачи данных",
      priceTitle: "Ежемесячная плата",
      priceDesc: "Фиксированная цена с учетом НДС",
      featuresTitle: "Особенности тарифа",
      featuresDesc: "Все услуги, включенные в тариф",
      applyNow: "Подать заявку",
      contactUs: "Связаться с нами",
      note: "Цены включают НДС. Услуга зависит от наличия инфраструктуры.",
      notFound: "Тариф не найден.",
      notFoundDesc: "Возможно, искомый тариф не существует или был удален.",
    },
    services: {
      title: "Услуги",
      subtitle: "Полные решения для подключения вашего дома и бизнеса.",
    },
    about: {
      title: "О нас",
      subtitle: "Соединяем наш регион с интернетом будущего.",
      storyTitle: "Наша история",
      p1: "ENTA-NET TELEKOMÜNİKASYON VE BİLGİ TEKNOLOJİLERİ TİCARET LİMİTED ŞİRKETİ — интернет-провайдер, основанный в Силифке (Мерсин), цель которого — обеспечить регион высокоскоростным и надёжным интернетом.",
      p2: "С момента основания мы прокладываем современную оптоволоконную инфраструктуру в районы, недостаточно охваченные крупными операторами, обеспечивая интернет столичного качества каждому дому и бизнесу.",
      p3: "Будучи местной компанией, мы относимся к абонентам как к соседям, а не как к номерам клиентов. Наша техническая команда работает по принципам реагирования в тот же день, поддержки 08:00 - 20:00 и прозрачных цен.",
      missionTitle: "Наша миссия",
      missionText: "Обеспечить быстрый, бесперебойный и доступный интернет каждому дому и бизнесу в нашем регионе.",
      visionTitle: "Наше видение",
      visionText: "Стать самой надёжной региональной телекоммуникационной компанией, ведущей цифровую трансформацию Мерсина и окрестностей.",
      valuesTitle: "Наши ценности",
      value1: "Надёжность",
      value1Desc: "Мы держим слово и обеспечиваем обещанную скорость.",
      value2: "Местные корни",
      value2Desc: "Мы знаем свой регион и относимся к абонентам как к соседям.",
      value3: "Инновации",
      value3Desc: "Мы постоянно улучшаем инфраструктуру и привносим новейшие технологии.",
    },
    blog: {
      title: "Блог и новости",
      subtitle: "Новости, технологические гайды и объявления от EntaNET.",
      readMore: "Читать далее",
      back: "Все статьи",
      empty: "Статей пока нет.",
    },
    campaigns: {
      title: "Акции",
      subtitle: "Не упустите эксклюзивные предложения.",
      apply: "Воспользоваться акцией",
      empty: "Сейчас нет активных акций.",
    },
    faq: {
      title: "Часто задаваемые вопросы",
      subtitle: "Быстрые ответы на ваши вопросы.",
      moreTitle: "Не нашли ответ?",
      moreText: "Наша команда доступна 08:00 - 20:00 для любых вопросов.",
      moreCta: "Связаться с нами",
    },
    contact: {
      title: "Контакты",
      subtitle: "Мы здесь для ваших вопросов, заявок и запросов в поддержку.",
      formTitle: "Напишите нам",
      name: "Имя и фамилия",
      email: "Эл. почта",
      phone: "Телефон",
      subject: "Тема",
      message: "Ваше сообщение",
      send: "Отправить",
      sending: "Отправка...",
      success: "Ваше сообщение отправлено. Мы скоро свяжемся с вами.",
      error: "Не удалось отправить сообщение. Попробуйте ещё раз.",
      infoTitle: "Контактная информация",
      addressLabel: "Адрес",
      phoneLabel: "Телефон",
      emailLabel: "Эл. почта",
      hoursLabel: "Часы работы",
      hours: "Понедельник - Суббота: 09:00 - 18:00",
      consentIntro: "Я прочитал и принимаю ",
      termsLink: "Условия использования",
      consentMid: " и ",
      privacyLink: "Политику конфиденциальности",
      consentOutro: ".",
      consentRequired: "Пожалуйста, примите условия использования и политику конфиденциальности, чтобы продолжить.",
    },
    footer: {
      tagline: "Высокоскоростной оптоволоконный интернет для Силифке и окрестностей. Местная сила, глобальная скорость.",
      quickLinks: "Быстрые ссылки",
      services: "Услуги",
      contact: "Контакты",
      rights: "Все права защищены.",
    },
    cookie: {
      title: "Мы используем файлы cookie",
      text: "Мы используем файлы cookie для улучшения вашего опыта на сайте. В соответствии с законом № 6698 (KVKK) и GDPR вы можете принять использование cookie или управлять настройками.",
      policyLink: "Политика cookie",
      acceptAll: "Принять все",
      reject: "Только необходимые",
      settings: "Настройки",
      close: "Закрыть",
      catNecessary: "Необходимые cookie",
      catNecessaryDesc: "Требуются для корректной работы сайта. Нельзя отключить.",
      catAnalytics: "Аналитические cookie",
      catAnalyticsDesc: "Используются для анализа использования сайта и улучшения опыта.",
      catMarketing: "Маркетинговые cookie",
      catMarketingDesc: "Используются для показа релевантного контента и рекламы.",
      save: "Сохранить настройки",
      poweredBy: "Соответствие KVKK и GDPR",
    },
    common: {
      loading: "Загрузка...",
    },
    comingSoon: {
      badge: "В РАЗРАБОТКЕ",
      title1: "Обновлённый цифровой",
      title2: "опыт",
      subtitle:
        "Мы тщательно создаём наш новый корпоративный сайт. До его запуска наши услуги продолжаются без перерыва.",
      paymentBtn: "Нажмите, чтобы оплатить",
      paymentNote: "Вы будете безопасно перенаправлены на наш онлайн-портал оплаты.",
      contactTitle: "Связаться с нами",
      brandTagline: "Волоконная инфраструктура Силифке — местная сила, глобальная скорость.",
    },
  },

  ar: {
    nav: {
      home: "الرئيسية",
      packages: "الباقات",
      services: "الخدمات",
      corporate: "من نحن",
      onlineBasvuru: "طلب إلكتروني",
      campaigns: "العروض",
      blog: "المدونة",
      faq: "الأسئلة الشائعة",
      contact: "اتصل بنا",
      online: "الخدمات الإلكترونية",
      applyNow: "قدّم الآن",
      callYou: "نتصل بك",
      coverage: "تحقق من التغطية",
      individual: "أفراد",
      speedTest: "اختبار السرعة",
      fastActions: "إجراءات سريعة",
    },
    hero: {
      badge: "البنية التحتية للألياف في سيليفكه",
      title1: "إنترنت",
      title2: "بسرعة الضوء.",
      subtitle:
        "اكتشف تقنية الألياف حتى المنزل مع EntaNET. سرعات تصل إلى 100 ميجابت، استخدام غير محدود ودعم فني محلي من 08:00 إلى 20:00.",
      ctaPackages: "تصفح الباقات",
      ctaContact: "تواصل معنا",
      coverageTitle: "تحقق من التغطية",
      coveragePlaceholder: "أدخل الحي / العنوان...",
      coverageBtn: "تحقق",
      onlineBasvuruTitle: "طلب إلكتروني عبر e-Devlet",
      onlineBasvuruDesc: "قدّم طلب اشتراك آمن وسريع عبر e-Devlet",
      onlineBasvuruBtn: "قدّم الآن",
      onlineBasvuruFeat1: "التحقق الفوري من الهوية عبر e-Devlet",
      onlineBasvuruFeat2: "رقمي بالكامل، بدون أوراق",
      onlineBasvuruFeat3: "أكمل طلبك في ثوانٍ",
      statSpeed: "السرعة القصوى",
      statSpeedNote: "تواصل معنا لسرعات أعلى",
      statSupport: "الدعم الفني",
      statUptime: "وقت التشغيل",
      statLocal: "خدمة محلية",
      slide1Badge: "غير محدود وبدون التزام",
      slide1Title: "سرعة غير محدودة،",
      slide1Title2: "إنترنت بدون التزام",
      slide1Desc: "سرعات تصل إلى 100 ميجابت، استخدام غير محدود ودعم محلي 08:00 - 20:00.",
      slide2Badge: "قوة محلية",
      slide2Title: "البنية التحتية",
      slide2Title2: "للألياف في سيليفكه",
      slide2Desc: "ألياف حتى المنزل بخدمة كالجيران.",
      slide3Badge: "اتصل الآن",
      slide3Title: "طلب سريع،",
      slide3Title2: "اتصال سريع",
      slide3Desc: "قدّم طلبك اليوم واحصل على إنترنت الألياف خلال 1-3 أيام عمل.",
    },
    home: {
      whyTitle: "لماذا EntaNET؟",
      whySubtitle: "نجمع بين أقوى بنية تحتية للألياف في المنطقة وعقلية الخدمة المحلية.",
      why1Title: "بنية ألياف حقيقية",
      why1Desc: "مع الألياف حتى المنزل (FTTH)، تحصل فعلًا على السرعة التي نعد بها.",
      why2Title: "استخدام غير محدود",
      why2Desc: "لا حصص استخدام عادل. حمّل وشاهد والعب كما تشاء.",
      why3Title: "دعم محلي 08:00 - 20:00",
      why3Desc: "لا متاهات مراكز اتصال. فريقنا في سيليفكه بجانبك من 08:00 إلى 20:00.",
      why4Title: "أسعار شفافة",
      why4Desc: "لا رسوم خفية ولا زيادات مفاجئة. تعرف دائمًا ما تدفعه.",
      packagesTitle: "اختر الباقة المناسبة لك",
      packagesSubtitle: "باقات إنترنت الألياف لكل احتياج وميزانية.",
      priceNoticeTitle: "إعلان",
      priceNotice: "أعزاءنا مستخدمي Enta-Net، نظرًا لتحديثات أسعار خدمات الجملة المعتمدة بقرار BTK رقم 2026/DK-ETD/134 وما ترتب عليها من زيادة في تكاليفنا، أصبح من الضروري تحديث أسعار خدمات الإنترنت لدينا اعتبارًا من 17.08.2026. الأسعار المحدّثة منشورة على موقعنا الإلكتروني. نشكركم على تفهّمكم وثقتكم بنا. لا تترددوا في التواصل معنا لأي استفسار أو للحصول على معلومات مفصّلة.",
      priceNoticeDate: "تاريخ الإعلان: 17.07.2026",
      priceTable: {
        title: "باقاتنا المتأثرة بتغيير الأسعار",
        colName: "اسم الباقة",
        colPrice: "السعر",
      },
      allPackages: "عرض جميع الباقات",
      servicesTitle: "خدماتنا",
      servicesSubtitle: "عنوان واحد لجميع احتياجات الاتصال المنزلية والتجارية.",
      campaignsTitle: "العروض الحالية",
      offerFeat1: "سرعة تحميل تصل إلى 100 ميجابت",
      offerFeat2: "ضمان سعر ثابت لمدة 12 شهرًا",
      offerFeat3: "بدون التزام، ألغِ في أي وقت",
      offerFeat4: "موافقة رقمية فورية عبر e-Devlet",
      ctaTitle: "هل أنت مستعد لتجربة حرية السرعة؟",
      ctaSubtitle: "قدّم طلبك اليوم واحصل على إنترنت الألياف خلال 1-3 أيام عمل.",
      ctaButton: "قدّم الآن",
    },
    packages: {
      title: "الباقات",
      subtitle: "باقات إنترنت ألياف غير محدودة بأسعار شفافة وخيارات التزام.",
      perMonth: "/شهر",
      popular: "الأكثر شعبية",
      select: "تفاصيل الباقة",
      mbps: "ميجابت",
      note: "الأسعار تشمل الضرائب. الخدمة تخضع لتوفر البنية التحتية.",
    },
    packageDetail: {
      back: "العودة إلى الباقات",
      speedTitle: "سرعة التحميل",
      speedDesc: "الحد الأقصى لمعدل نقل البيانات في الثانية",
      priceTitle: "الرسوم الشهرية",
      priceDesc: "سعر ثابت شامل الضرائب",
      featuresTitle: "ميزات الباقة",
      featuresDesc: "جميع الخدمات المضمنة في هذه الباقة",
      applyNow: "قدّم الآن",
      contactUs: "اتصل بنا",
      note: "الأسعار تشمل الضرائب. الخدمة تخضع لتوفر البنية التحتية.",
      notFound: "الباقة غير موجودة.",
      notFoundDesc: "قد لا تكون الباقة التي تبحث عنها موجودة أو قد تمت إزالتها.",
    },
    services: {
      title: "الخدمات",
      subtitle: "حلول اتصال متكاملة لمنزلك وعملك.",
    },
    about: {
      title: "من نحن",
      subtitle: "نربط منطقتنا بإنترنت المستقبل.",
      storyTitle: "قصتنا",
      p1: "شركة ENTA-NET TELEKOMÜNİKASYON VE BİLGİ TEKNOLOJİLERİ TİCARET LİMİTED ŞİRKETİ هي مزود خدمة إنترنت تأسست في سيليفكه بمرسين، وتكرّس جهودها لتوفير وصول إنترنت عالي السرعة وموثوق لمنطقتها.",
      p2: "منذ تأسيسنا، ننقل البنية التحتية الحديثة للألياف إلى المناطق التي لم تخدمها كبرى الشركات بشكل كافٍ، ونقدم إنترنت بجودة المدن الكبرى لكل منزل وشركة.",
      p3: "بقوة كوننا شركة محلية، نعامل مشتركينا كجيران وليس كأرقام عملاء. يعمل فريقنا الفني بمبادئ الاستجابة في نفس اليوم والدعم من 08:00 إلى 20:00 والأسعار الشفافة.",
      missionTitle: "مهمتنا",
      missionText: "توفير وصول إنترنت سريع ومستمر وبأسعار معقولة لكل منزل وشركة في منطقتنا.",
      visionTitle: "رؤيتنا",
      visionText: "أن نكون شركة الاتصالات الإقليمية الأكثر موثوقية التي تقود التحول الرقمي في مرسين وما حولها.",
      valuesTitle: "قيمنا",
      value1: "الموثوقية",
      value1Desc: "نفي بوعدنا ونقدم السرعة التي نعد بها.",
      value2: "الجذور المحلية",
      value2Desc: "نعرف منطقتنا ونعامل مشتركينا كجيران.",
      value3: "الابتكار",
      value3Desc: "نطور بنيتنا التحتية باستمرار وننقل أحدث التقنيات إلى منطقتنا.",
    },
    blog: {
      title: "المدونة والأخبار",
      subtitle: "أخبار وأدلة تقنية وإعلانات من EntaNET.",
      readMore: "اقرأ المزيد",
      back: "جميع المقالات",
      empty: "لا توجد مقالات بعد.",
    },
    campaigns: {
      title: "العروض",
      subtitle: "لا تفوّت العروض الحصرية.",
      apply: "استفد من العرض",
      empty: "لا توجد عروض نشطة حاليًا.",
    },
    faq: {
      title: "الأسئلة الشائعة",
      subtitle: "إجابات سريعة على أسئلتك.",
      moreTitle: "لم تجد إجابتك؟",
      moreText: "فريقنا متاح من 08:00 إلى 20:00 لجميع أسئلتك.",
      moreCta: "تواصل معنا",
    },
    contact: {
      title: "اتصل بنا",
      subtitle: "نحن هنا لأسئلتك وطلباتك واستفسارات الدعم.",
      formTitle: "اكتب لنا",
      name: "الاسم الكامل",
      email: "البريد الإلكتروني",
      phone: "الهاتف",
      subject: "الموضوع",
      message: "رسالتك",
      send: "إرسال",
      sending: "جارٍ الإرسال...",
      success: "تم إرسال رسالتك بنجاح. سنرد عليك قريبًا.",
      error: "تعذر إرسال الرسالة. حاول مرة أخرى.",
      infoTitle: "معلومات الاتصال",
      addressLabel: "العنوان",
      phoneLabel: "الهاتف",
      emailLabel: "البريد الإلكتروني",
      hoursLabel: "ساعات العمل",
      hours: "الاثنين - السبت: 09:00 - 18:00",
      consentIntro: "لقد قرأت ووافقت على ",
      termsLink: "شروط الاستخدام",
      consentMid: " و",
      privacyLink: "سياسة الخصوصية",
      consentOutro: ".",
      consentRequired: "يرجى قبول شروط الاستخدام وسياسة الخصوصية للمتابعة.",
    },
    footer: {
      tagline: "إنترنت ألياف عالي السرعة لسيليفكه وما حولها. قوة محلية، سرعة عالمية.",
      quickLinks: "روابط سريعة",
      services: "الخدمات",
      contact: "اتصل بنا",
      rights: "جميع الحقوق محفوظة.",
    },
    cookie: {
      title: "نستخدم ملفات تعريف الارتباط (الكوكيز)",
      text: "نستخدم ملفات تعريف الارتباط لتقديم تجربة أفضل على موقعنا. بموجب قانون KVKK رقم 6698 وGDPR، يمكنك قبول استخدامنا للكوكيز أو إدارة إعداداتك.",
      policyLink: "سياسة الكوكيز",
      acceptAll: "قبول الكل",
      reject: "الضرورية فقط",
      settings: "الإعدادات",
      close: "إغلاق",
      catNecessary: "الكوكيز الضرورية",
      catNecessaryDesc: "مطلوبة لتشغيل الموقع بشكل صحيح. لا يمكن تعطيلها.",
      catAnalytics: "كوكيز التحليلات",
      catAnalyticsDesc: "تُستخدم لتحليل استخدام الموقع وتحسين التجربة.",
      catMarketing: "كوكيز التسويق",
      catMarketingDesc: "تُستخدم لتقديم محتوى وإعلانات تتوافق مع اهتماماتك.",
      save: "حفظ الإعدادات",
      poweredBy: "متوافقة مع KVKK و GDPR",
    },
    common: {
      loading: "جارٍ التحميل...",
    },
    comingSoon: {
      badge: "تحت الإنشاء",
      title1: "تجربة رقمية",
      title2: "متجدّدة",
      subtitle:
        "نعمل بعناية على موقعنا الإلكتروني الجديد. وحتى جاهزيته، تستمر خدماتنا دون انقطاع.",
      paymentBtn: "اضغط لإتمام الدفع",
      paymentNote: "سيتم تحويلك بأمان إلى بوابة الدفع الإلكتروني الخاصة بنا.",
      contactTitle: "تواصل معنا",
      brandTagline: "البنية التحتية الليفية لسيليفكي — قوة محلية، سرعة عالمية.",
    },
  },
};

